export default __webpack_public_path__ + "static/media/blank.64d2d6a4.jpg";